import React from 'react'
import './footer.css'

function footer() {
    return (
        <div className='footer-container'>
            <section className="footer-subscription">
                <h1 className="footer-subscription-heading">Made by Brian Kibet(<small><i>Full Stack Developer,SFC</i></small>)&copy;</h1>
            </section>
        </div>
    )
}

export default footer
